import { createContext, useEffect, useState } from "react";
import {
    collection,
    getDocs,
    getDoc,
    doc,
    setDoc,
    addDoc,
    deleteDoc,
    onSnapshot,
    query,
    orderBy
} from "firebase/firestore";
import { db } from '../firebaseConfig';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {

    const [data, setData] = useState(null);

    useEffect(() => {
        const unSubscribe = onSnapshot(
           query( collection(db, 'portafolio'),
            orderBy('createdAt', 'desc')),
            (docs) => {
                let list = [];
                docs.forEach(doc => {
                    list.push({ ...doc.data(), id: doc.id });
                })
                setData(list);
            });

        return () => unSubscribe();



    }, [])

    const getDataById = async (id) => {
        const docRef = doc(db, 'portafolio', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists) {
            const work = {
                ...docSnap.data(),
                id: docSnap.id
            }
            return work;
        } else {
            return null;
        }
    }

    const saveDataByid = (work) => {
        let workRef;
        if (work.id) {
            workRef = doc(db, 'portafolio', work.id);
            return setDoc(workRef, work);

        } else {
            workRef = collection(db, 'portafolio');
            return addDoc(workRef, {...work, createdAt: new Date()});
        }

    }

    const deleteDataById = (id) => {
        const docRef = doc(db, 'portafolio', id);
        return deleteDoc(docRef);
    }


    return (
        <DataContext.Provider value={{ data, getDataById, saveDataByid, deleteDataById }}>
            {children}
        </DataContext.Provider>
    )
}
